<template lang="pug">
  .about
    .about__banner
      h1.about__banner_center-text.white--text Quem somos
    .about__content.max-content.primary--text
      img.image(src='@/assets/img/svg/logo-default.svg')
      p.text-center.mb-8 Idealizado diante de uma necessidade em resolver uma carência na automação e agilidade de
        | pagamentos presenciais, com um produto intuitivo e interface amigável.
        | Projetado para o mercado de provedor de internet, com ampla possibilidade de personalização para outros
        | seguimentos.
      strong.mt-5 MISSÃO
      p.text-center Automatizar processo de atendimento ao cliente, 
        br 
        | transformando tempo em qualidade de vida. 
      strong.mt-5 VISÃO
      p.text-center Nosso objetivo é ser uma empresa de referência na 
        br
        | automatização de processos no atendimento ao cliente. 
      //- p.text-center Criarmos soluções inteligentes que vão de encontro
      //-   br
      //-   | com as necessidades do nosso mercado.
      strong.mt-5 VALORES
      p.text-center Integridade, humildade e cumplicidade.
    .about__banner-2
      .about__banner-2_text.white--text.text-center
        h3 Fale com um consultor
          br
          | e conheça todas as
          br
          | vantagens.
        v-btn.text-capitalize.font-weight-black.primary(rounded dark :to="{ name: 'Contact' }") Clique Aqui!
    
</template>

<script>
export default {
  name: 'about-page',
}
</script>

<style lang="sass" scoped>
@import "@/assets/style/mobileFirst.sass"
@import "@/assets/style/variables.sass"

.about
  background: $white
  &__banner
    min-height: 200px
    background-position: center
    background-image: url('../assets/img/bg-about-1.jpg')
    background-size: cover
    position: relative
    +media-min-md
      min-height: 40vh
    +media-min-lg
    &_center-text
      position: absolute
      top: 50%
      left: 50%
      transform: translate(-50%, -50%)

  &__banner-2
    background-image: url('../assets/img/bg-about-2.jpg')
    background-size: cover
    min-height: 570px
    position: relative
    overflow: hidden
    background-position: right
    +media-min-md
      background-position: center
      background-size: cover
      min-height: 100vh
    &_text
      position: absolute
      line-height: 25px
      left: 50%
      top: 50%
      transform: translate(-50%, -50%)
      width: 100%
      +media-min-md
        left: 12%
        top: 35%
        width: auto
        transform: translate(0, -50%)
        left: 12%
        line-height: 35px
      h3
        font-size: 25px
        +media-min-md
          font-size: 35px
      .v-btn
        margin-top: 15px
        letter-spacing: normal
        font-size: 1.1rem
        +media-min-md
          font-size: 2rem

  &__content
    display: flex
    flex-direction: column
    align-items: center
    padding: 50px 20px
    .image
      width: 30%
      margin-bottom: 10px
    p
      +media-min-md
        font-size: 22px
        padding: 0 185px
      +media-min-xl
        padding: 0 150px
    strong
      font-size: 22px
      +media-min-md
        font-size: 24px

      
</style>